import AcceptedServices from './AcceptedServices';
export default AcceptedServices;
